import { Stack, TextField, Typography } from "@mui/material"

export const FormVariableStatus = ({ formValues, handleInputChange }) => {

    const { dateRentalEntry, rentAbatementDate, dateGetMaterial, changes, status, dateRentalEnd } = formValues

    return (
        <Stack flexDirection='row' width='100%' spacing={1} flexWrap='wrap' justifyContent='space-around' gap={1}>
            <Stack width='100%'>
                <Typography textAlign='center' variant="subtitle" color="primary">Cambios estado de obra</Typography>
            </Stack>
            {(status === 'Montada')
                && <Stack width='90%' flexDirection='row' justifyContent='space-around' alignItems='flex-end'>
                    <label >Fecha de alta del alquiler:</label >
                    <TextField
                        sx={{ width: '200px', height: '30px' }}
                        type="date"
                        variant="standard"
                        name='dateRentalEntry'
                        value={dateRentalEntry ? dateRentalEntry : ''}
                        onChange={handleInputChange}
                        required
                    />
                </Stack>
            }
            {(status === 'Pendiente de desmontaje')
                && <Stack width='90%' flexDirection='row' justifyContent='space-around' alignItems='flex-end'>
                    <label >Fecha de baja del alquiler:</label >
                    <TextField
                        sx={{ width: '200px', height: '30px' }}
                        type="date"
                        variant="standard"
                        name='dateRentalEnd'
                        value={dateRentalEnd ? dateRentalEnd : ''}
                        onChange={handleInputChange}
                        required
                    />
                </Stack>
            }
            {(status === 'Pendiente de recogida')
                && <Stack width='90%' flexDirection='row' justifyContent='space-around' alignItems='flex-end'>
                    <label >Fecha de desmontaje de material:</label >
                    <TextField
                        sx={{ width: '200px', height: '30px' }}
                        type="date"
                        variant="standard"
                        name='rentAbatementDate'
                        value={rentAbatementDate ? rentAbatementDate : ''}
                        onChange={handleInputChange}
                        required
                    />
                </Stack>
            }
            {(status === 'Terminada')
                && <Stack width='90%' flexDirection='row' justifyContent='space-around' alignItems='flex-end'>
                    <label >Fecha de recogida de material:</label >
                    <TextField
                        sx={{ width: '200px', height: '30px' }}
                        type="date"
                        variant="standard"
                        name='dateGetMaterial'
                        value={dateGetMaterial ? dateGetMaterial : ''}
                        onChange={handleInputChange}
                        required
                    />
                </Stack>
            }
            <TextField
                sx={{ width: '90%'}}
                type="search"
                variant="filled"
                label='Modificaciones'
                name='changes'
                multiline
                value={changes ? changes : ''}
                onChange={handleInputChange}
            />
        </Stack>
    )
}